import { getCauses } from '@printdeal/business-logic';
import LineItem from '../types/cart/LineItem';
import { UploadAttachments } from '../types/complaints';

interface ComplaintLineItemProp {
  merchantItemId: string,
  quantity: number
}

interface LineItemNamesProps {
  name: string,
  quantity: number
}

export const complaintLineItemNames = (
  orderLineItems: LineItem[] = [],
  complaintLineItems: ComplaintLineItemProp[] = [],
) => {
  const lineItemNames: LineItemNamesProps[] = [];
  complaintLineItems.forEach((cLineItem) => {
    const lineItem = orderLineItems.find((oLineItem) => (
      oLineItem.custom?.fields?.lineItemNumber === cLineItem.merchantItemId
    ));
    if (lineItem) {
      lineItemNames.push({ name: lineItem.custom?.fields?.merchandisingProductName, quantity: cLineItem.quantity });
    }
  });

  return lineItemNames;
};

export const getAttachmentDetails = (attachments: UploadAttachments[]) =>
  attachments.map((upload) => {
    const { urls, fileType, uploadTitle } = upload;

    return {
      href: urls.originalUrl,
      contentType: fileType,
      description: uploadTitle,
    };
  });

/**
 * Determine the visibility of the attachments field, unique for launchpad.
 * @param complaintReason
 * @return boolean
 */
export const shouldShowAttachmentField = (complaintReason: string) => {
  const causes = getCauses();
  const whitelistedCauses = [
    causes.DOES_NOT_MEET_EXPECTATIONS.mappedMcpKey,
    causes.DELIVERED_DAMAGED.mappedMcpKey,
    causes.DAMAGED_PRODUCT.mappedMcpKey,
  ];

  return whitelistedCauses.includes(complaintReason);
};
